import React, { useState, useEffect } from "react";
import Modal from "reactstrap/lib/Modal";
import ModalBody from "reactstrap/lib/ModalBody";
import widgetImage1 from "./assets/url_to_widget1.png";
import widgetImage2 from "./assets/url_to_widget2.png";
import widgetImage3 from "./assets/url_to_widget3.png";
import widgetImage4 from "./assets/url_to_widget4.png";
import WidgetModel1 from "./WidgetModel1";
import WidgetModel2 from "./WidgetModel2";
import WidgetModel3 from "./WidgetModel3";
import WidgetModel4 from "./WidgetModel4";

const widgetOptions = [
  { value: "", text: "-select-", image: "", model: null },
  {
    value: "Widget Type 1",
    text: "Widget type 1",
    image: widgetImage1,
    model: WidgetModel1,
  },
  {
    value: "Widget Type 2",
    text: "Widget type 2",
    image: widgetImage2,
    model: WidgetModel2,
  },
  {
    value: "Widget Type 3",
    text: "Widget type 3",
    image: widgetImage3,
    model: WidgetModel3,
  },
  {
    value: "Widget Type 4",
    text: "Widget type 4",
    image: widgetImage4,
    model: WidgetModel4,
  },
];

const getAllowedWidgetOptions = (layoutType, boxIdx) => {
  if (!layoutType) return widgetOptions;
  if (layoutType === "landscape") {
    return widgetOptions;
  } else if (layoutType === "potrait") {
    return widgetOptions.filter((opt) =>
      ["", "Widget Type 1", "Widget Type 4"].includes(opt.value)
    );
  } else if (layoutType === "leftmixed") {
    return boxIdx === 0
      ? widgetOptions.filter((opt) =>
          ["", "Widget Type 1", "Widget Type 4"].includes(opt.value)
        )
      : widgetOptions;
  } else if (layoutType === "rightmixed") {
    return boxIdx === 0
      ? widgetOptions
      : widgetOptions.filter((opt) =>
          ["", "Widget Type 1", "Widget Type 4"].includes(opt.value)
        );
  }
  return widgetOptions;
};

const WidgetControllerModal = ({
  isModalOpen,
  closeModal,
  widget,
  setWidget,
  onSave,
  layoutType,
  boxIdx,
}) => {
  const [selectedType, setSelectedType] = useState(
    widget ? widget.widgetType : ""
  );
  const [widgetData, setWidgetData] = useState(
    widget || { widgetType: "", widgetRequirement: {} }
  );

  useEffect(() => {
    setWidgetData(widget || { widgetType: "", widgetRequirement: {} });
    setSelectedType(widget ? widget.widgetType : "");
  }, [widget]);

  const availableWidgetOptions = getAllowedWidgetOptions(layoutType, boxIdx);
  const selectedOption =
    availableWidgetOptions.find((opt) => opt.value === selectedType) ||
    availableWidgetOptions[0];
  const ModelComp = selectedOption.model;

  const handleTypeChange = (e) => {
    const type = e.target.value;
    setSelectedType(type);
    setWidgetData({ widgetType: type, widgetRequirement: {} });
  };

  function isHtmlContentEmpty(htmlContent) {
    if (!htmlContent) return true;
    // Remove all tags and whitespace
    const text = htmlContent.replace(/<[^>]*>/g, "").replace(/\s+/g, "");
    return text.length === 0;
  }

  const isWidgetSaveDisabled = (widgetData) => {
    const { widgetType, widgetRequirement = {} } = widgetData || {};
    if (widgetType === "Widget Type 1") {
      return (
        !widgetRequirement.image ||
        !widgetRequirement.imageTitle ||
        isHtmlContentEmpty(widgetRequirement.htmlContent)
      );
    }
    if (widgetType === "Widget Type 2" || widgetType === "Widget Type 3") {
      return (
        !widgetRequirement.image ||
        isHtmlContentEmpty(widgetRequirement.htmlContent)
      );
    }
    if (widgetType === "Widget Type 4") {
      return isHtmlContentEmpty(widgetRequirement.htmlContent);
    }
// For "-select-" or any other, always disable
    return true;
  };

  return (
    <Modal
      className="content-adminConfirmation-popup-modal"
      isOpen={isModalOpen}
      backdrop
      keyboard={false}
      wrapClassName="modal-primary"
      size="lg"
    >
      <div className="modal-title-color contentDetails-modal-title">
        <h5>
          <strong>Configure Widget</strong>
        </h5>
        <h6>You are editing Row Widget</h6>
      </div>
      <ModalBody>
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 32,
            marginBottom: 20,
          }}
        >
          <div style={{ flex: 1, minWidth: 240 }}>
            <label htmlFor="widgetType">
              <b>Select a Widget Type</b>
            </label>
            <select
              id="widgetType"
              className="form-control"
              value={selectedType}
              onChange={handleTypeChange}
              style={{
                marginBottom: 12,
                fontSize: "1.1rem",
                height: "50px",
                minWidth: 220,
              }}
            >
              {availableWidgetOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.text}
                </option>
              ))}
            </select>
          </div>
          <div
            style={{
              flex: 1,
              textAlign: "center",
              minWidth: 240,
              maxWidth: 320,
              overflow: "hidden",
            }}
          >
            {selectedOption.image && (
              <div>
                <div
                  style={{
                    marginBottom: 8,
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                  }}
                >
                  Template Design
                </div>
                <img
                  src={selectedOption.image}
                  alt={selectedOption.text}
                  style={{
                    display: "block",
                    margin: "0 auto",
                    maxHeight: 160,
                    maxWidth: "100%",
                    width: "100%",
                    height: "auto",
                    border: "1px solid #ccc",
                    borderRadius: 8,
                    objectFit: "contain",
                  }}
                />
              </div>
            )}
          </div>
        </div>
        {ModelComp && (
          <ModelComp
            initialData={widgetData.widgetRequirement}
            onChange={(data) =>
              setWidgetData((w) => ({
                ...w,
                widgetType: selectedType,
                widgetRequirement: data,
              }))
            }
            closeModal={closeModal}
          />
        )}
        <div className="content-adminConfirmationModal-popup-button">
          <button
            type="button"
            onClick={() => {
              onSave(widgetData);
              closeModal();
            }}
            className="btn btn-primary content-adminConfirmationModal-button btn-rounded"
            disabled={isWidgetSaveDisabled(widgetData)}
          >
            Save
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="btn btn-primary content-adminConfirmationModal-button btn-rounded"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => {
              setWidgetData({ widgetType: "", widgetRequirement: {} });
              setSelectedType("");
            }}
            className="btn btn-primary content-adminConfirmationModal-button btn-rounded"
          >
            Reset
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default WidgetControllerModal;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Content Management/WidgetControllerModal.js